export const ADD_ECO_PACKAGING_MUTATION = `
mutation CartMutation{
  addEcoPackaging {
    data{
      serviceItems {
          ecoPackaging {
              productId
              productCode
              itemId
              count
              vat
              priceWithVat
              priceSumWithVat
          }
      }
      pricesSummary {
          vat
          priceItemSummary
          pricePayment
          priceDelivery
          priceProductsSummary
          discountWithoutDelivery
      }
    }
    messages
  }
}
`;
